module.exports = __webpack_public_path__ + "img/image23.27fd423b.jpg";